/* "Our story": blokken infaden zodra ze in beeld komen (vervangt aos.js uit NL). Zonder IntersectionObserver
   of met reduced motion gebeurt er niets en staat alles direct in beeld. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function start() {
    var wortels = document.querySelectorAll('.mv-ov');
    if (!wortels.length) return;
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        if (it.isIntersecting) {
          it.target.classList.add('is-zichtbaar');
          io.unobserve(it.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    wortels.forEach(function (w) {
      w.classList.add('mv-ov-js');
      w.querySelectorAll('.mv-ov-in').forEach(function (el) { io.observe(el); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // theme editor: sectie opnieuw gerenderd
  document.addEventListener('shopify:section:load', start);
})();
